import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SECURE_API_URLS, API_URLS } from '../config/api.urls';
import { AdBanner } from '../_models/ad-banner';
import { IPagination } from '../_models/pagination';

@Injectable({ providedIn: 'root' })
export class AdBannerService {

    constructor(private http: HttpClient) {}

    loadAll(page: number = 1): Observable<IPagination> {
        return this.http
            .get<{ message: any; data: IPagination }>(`${SECURE_API_URLS.AD_BANNERS_BASE_URL}?page=${page}&size=20`)
            .pipe(map(res => res.data));
    }

    loadById(id: string): Observable<AdBanner> {
        return this.http
            .get<{ message: any; data: AdBanner }>(`${SECURE_API_URLS.AD_BANNERS_BASE_URL}/${id}`)
            .pipe(map(res => res.data));
    }

    loadByGroup(bannerGroup: string): Observable<AdBanner[]> {
        return this.http
            .get<{ message: any; data: AdBanner[] }>(`${API_URLS.AD_BANNERS_BASE_URL}?bannerGroup=${bannerGroup}`)
            .pipe(map(res => res.data));
    }

    create(file: File, data: { bannerGroup: string; position: number; url: string }): Observable<AdBanner> {
        const formData = new FormData();
        formData.append('file', file);
        const dataBlob = new Blob([JSON.stringify(data)], { type: 'application/json' });
        formData.append('data', dataBlob);
        return this.http
            .post<{ message: any; data: AdBanner }>(SECURE_API_URLS.AD_BANNERS_BASE_URL, formData)
            .pipe(map(res => res.data));
    }

    update(id: string, file: File | null, data: { bannerGroup: string; position: number; url: string }): Observable<AdBanner> {
        const formData = new FormData();
        if (file) {
            formData.append('file', file);
        }
        const dataBlob = new Blob([JSON.stringify(data)], { type: 'application/json' });
        formData.append('data', dataBlob);
        return this.http
            .put<{ message: any; data: AdBanner }>(`${SECURE_API_URLS.AD_BANNERS_BASE_URL}/${id}`, formData)
            .pipe(map(res => res.data));
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${SECURE_API_URLS.AD_BANNERS_BASE_URL}/${id}`);
    }
}
